<div class="bg-primary-shade-fff">
    <div class="bg-Changepin-header pt-24 pb-24 pl-40 pr-40">
        <!-- <ng-icon iconClass="icon-imtiaz-header" width="90" height="72"></ng-icon> -->
        <ng-icon iconClass="icon-sahel-logo-trans" width="128" height="40"></ng-icon>

    </div>
    <grid-row class="justify-content-center p-50">
        <grid-col col="4" ipad="6" mobile="12">
            <div class="text-align-center">
                <ng-icon iconClass="icon-imtiaz-lock-bg" width="250" height="103"></ng-icon>
            </div>
            <div class="text-align-center mt-5">
                <ng-icon iconClass="icon-imtiaz-mastercard" width="126" height="78"></ng-icon>
            </div>
            <div class="font-400 font-size-20px color-base-700 mt-40">
                {{ "PleaseCompleteFieldsBelow" | translate }}
            </div>
            <div class="form-group mt-40">
                <label class="no-mark">
                    {{ "EnterYourCardNumber" | translate }}
                </label>
                <input type="number" [(ngModel)]="CardNumber" placeholder="Please enter">
            </div>
            <div class="form-group mt-30">
                <label class="no-mark">
                    {{ "EnterExistingdigitPin" | translate }}
                </label>
                <input type="password" [(ngModel)]="ExistingPin" placeholder="Please enter">
            </div>
            <div class="form-group mt-30">
                <label class="no-mark">
                    {{ "EnterNewdigitPin" | translate }}
                </label>
                <input type="password" [(ngModel)]="NewdigitPin" placeholder="Please enter">
            </div>
            <div class="form-group mt-30">
                <label class="no-mark">
                    {{ "EnterNewdigitPin" | translate }}
                </label>
                <input type="password" [(ngModel)]="DigitPin" placeholder="Please enter">
            </div>
            <button class="btn-dft mt-50" (click)="ChangeCardPinVerifyOTP()">
                {{ "CONFIRM" | translate }}
            </button>
        </grid-col>
    </grid-row>
    <div class="bg-base-200 p-24">
        <grid-row class="justify-content-center">
            <grid-col col="4" ipad="6" mobile="12">
                <div class="text-align-center">
                    <!-- <div class="border-bottom border-color-400 pb-10">
                        <span class="font-400 font-size-12px color-base-500">
                            {{ "ForAnyAssistanceCall" | translate }}
                        </span>
                        <span class="font-600 font-size-12px color-secondary">
                            8000 8000
                        </span>
                    </div> -->
                    <div class="pt-10 font-400 font-size-12px color-base-500">
                        {{ "FinancingCompanyLicensed" | translate }}
                    </div>
                </div>
            </grid-col>
        </grid-row>
    </div>
    <div class="bg-base-2200 p-40">
        <div class="text-align-center">
            <span class="font-400 font-size-12px color-base-100">
                {{ "2023" | translate }}
            </span>
            <span class="font-600 font-size-12px color-base-100">
                {{ "BahrainCredit" | translate }}
            </span>
            <span class="font-400 font-size-12px color-base-100">
                {{ "AllRightsReserved" | translate }}
            </span>
        </div>
        <div class="text-align-center mt-16">
            <!-- <ng-icon iconClass="icon-linkdin" width="32" height="32"></ng-icon>
            <ng-icon iconClass="icon-facebook ml-16" width="32" height="32"></ng-icon>
            <ng-icon iconClass="icon-instagram ml-16" width="32" height="32"></ng-icon>
            <ng-icon iconClass="icon-youtube ml-16" width="32" height="32"></ng-icon> -->

            <a href="https://www.linkedin.com/company/bcfc/" target="_blank">
                <!-- <ng-icon iconClass="icon-linkdin" width="32" height="32"></ng-icon> -->
                <ng-icon iconClass="icon-linkd-In-green bg-base-100 br-100" width="32" height="32"></ng-icon>
            </a>
            <a href="https://www.facebook.com/bahraincredit" target="_blank">
                <!-- <ng-icon iconClass="icon-facebook ml-16" width="32" height="32"></ng-icon> -->
                <ng-icon iconClass="icon-facebook-green bg-base-100 br-100 ml-16" width="32" height="32"></ng-icon>
            </a>
            <a href="https://www.instagram.com/bahraincredit/?hl=en" target="_blank">
                <!-- <ng-icon iconClass="icon-instagram ml-16" width="32" height="32"></ng-icon> -->
                <ng-icon iconClass="icon-insta-green bg-base-100 br-100 ml-16" width="32" height="32"></ng-icon>
            </a>
            <a href="https://www.youtube.com/channel/UC7ELvjKtP5XNl5l8LuH1-Vg" target="_blank">
                <!-- <ng-icon iconClass="icon-youtube ml-16" width="32" height="32"></ng-icon> -->
                <ng-icon iconClass="icon-you-tube-green bg-base-100 br-100 ml-16" width="32" height="32"></ng-icon>
            </a>
        </div>
    </div>
</div>